import type { FaireProductEntity } from "../../entity_types/product";

export const p_nwg9g6uj2t: FaireProductEntity = {
  token: "p_nwg9g6uj2t",
  type: "product",
  name: "14K Gold Diamond Curved Ring, Stackable Ring, Diamond Ring",
  brandToken: "b_tk6ffkngnw",
  brandName: "PureYou Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/f6b9e60acbb50ff8f69608a8b6b7d101a29b8cc1641fcaf0174f019293992d98.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76635df4141c1bb591e7420f4c5fda85b26655c12f6bf54bd57ae1f477ff46e1.png",
    "https://cdn.faire.com/fastly/9b98a802505ef68315fa8cbd4c4015db77858c68f1e36aa29a537523a682eaad.png",
    "https://cdn.faire.com/fastly/939ac4835ccb18e754d7b7d7f071739efdd8962a6fd6a4065dfdcdbc3a87d1ad.png",
    "https://cdn.faire.com/fastly/2903e41e4eb006e0d9972bfb360d10baa1d21af34a894c3da7ccdf0ea1442c38.png",
    "https://cdn.faire.com/fastly/bd1040183770ebc75c1636119e71cfc56ce26cd599eca405947c35811f4e95a7.png",
    "https://cdn.faire.com/fastly/c436b1eba84c8bfdb7ba65e24c28db72dd19ea8776616827dda25353541152b0.png",
    "https://cdn.faire.com/fastly/d07c75d2f2d3dd1a264dafaa25b0a619f79fa948587a0d01728915eff0e380bb.png",
    "https://cdn.faire.com/fastly/b8f636c0631d2de83783f1b511bb7fc8733e4df8af04d85606320731fbabbe37.png",
    "https://cdn.faire.com/fastly/189ea02ba758e22ae4d2e5f3c4f0d4ba96a4d4a5fe0ae6b38fc48df3888b4b82.png",
    "https://cdn.faire.com/fastly/c5517c195e4dba2b5e2901e287d566deadd3607b9c7ac05b9a5139e2dfeef715.png",
    "https://cdn.faire.com/fastly/ee59a8b24f00147786b9cbebd12718d186003a9b9f9dfed034b35dbc41f1965f.png",
  ],
  priceDollars: 1396.77,
  description:
    "Diamond Details:\nGemstone :Lab Grown Diamond\nStone Shape: Round, Princess, Emerald And Pear  \nDiamond Carat Weight: 0.32ctw\nWidth: 1.6mm\nColor: D-F\nCut: Excellent\nClarity: VVS2/VS\n\nMetal Details :\nMetal Option: 14k, 18k Stamped Solid Gold \nAvailable in: Yellow Gold, White Gold, Rose Gold\n\nRing Sizes range from 3-12 US. If you have any questions about sizing, please do not hesitate to reach out!\n\nAt PureYou, we are dedicated to excellent service and top-quality jewelry. Our lab-grown diamonds, with the same properties as natural ones, are IGI-certified and crafted by experts. We offer custom designs, fair pricing, no MOQ, no middlemen, and uphold ethical practices. All pieces are hypoallergenic, nickel-free, handcrafted, and made to order, with full customization available. Also offered in natural diamonds—message us anytime, we’re happy to help!",
  tags: [],
  msrpDollars: 2793.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:50.609Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
